import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { RowTeamShotsPerGame, StatsShotsChart } from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import toFixedOrInteger from '../../../utils/toFixedOrInteger';
import { useStatsData } from '../../../hooks';

const Shots = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.SHOTS,
  });

  if (!widget || widget.type !== ApiWidgetType.SHOTS || !widget?.data) {
    return null;
  }

  const { home: homeStats, away: awayStats } = widget.data;

  return (
    <Section name={translate('PreMatchStats.Shots')} contentClassName="flex flex-col gap-4">
      <RowTeamShotsPerGame
        homeNumber={toFixedOrInteger(homeStats.shotsPerGame, 1)}
        awayNumber={toFixedOrInteger(awayStats.shotsPerGame, 1)}
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
      />
      <StatsShotsChart
        homeOffTarget={homeStats.shotsOffTarget}
        homeOnTarget={homeStats.shotsOnTarget}
        awayOnTarget={awayStats.shotsOnTarget}
        awayOffTarget={awayStats.shotsOffTarget}
        homeConcededOffTarget={homeStats.shotsConcededOffTarget}
        homeConcededOnTarget={homeStats.shotsConcededOnTarget}
        awayConcededOnTarget={awayStats.shotsConcededOnTarget}
        awayConcededOffTarget={awayStats.shotsConcededOffTarget}
      />
    </Section>
  );
};

export default Shots;
